var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmptyComms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-empty-comms",
    transform: "translate(-550 -561)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    cx: 60,
    cy: 60,
    r: 60,
    transform: "translate(550 561)",
    fill: "#1a1b43",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3759",
    "data-name": "Group 3759",
    transform: "translate(580.002 591.504)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1496",
    "data-name": "Rectangle 1496",
    width: 59.996,
    height: 59.996,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-0.002 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M17.011,25.5",
    transform: "translate(17.013 23.492)",
    fill: "#1a1b43",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3759-2",
    "data-name": "Group 3759"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M24,57a2,2,0,0,1-2-2V46.491c-11.933-1.036-22-11.2-22-22.7A22.815,22.815,0,0,1,22.788,1H37.2a22.789,22.789,0,0,1,.45,45.573L25.254,56.552A1.986,1.986,0,0,1,24,57ZM22.788,5A18.81,18.81,0,0,0,4,23.788C4,33.8,13.345,42.577,24,42.577a2,2,0,0,1,2,2v6.24l9.681-7.8a1.988,1.988,0,0,1,1.254-.444h.26A18.789,18.789,0,0,0,37.2,5Z",
    transform: "translate(0.002 -1)",
    fill: "#1a1b43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3760",
    "data-name": "Group 3760",
    transform: "translate(32.57 49.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M16.284,25.551",
    transform: "translate(-16.284 -25.551)",
    fill: "#1a1b43",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    transform: "translate(23.962 18.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M17.92,21.909a5.94,5.94,0,1,1,5.94-5.94A5.945,5.945,0,0,1,17.92,21.909Zm0-7.879a1.94,1.94,0,1,0,1.94,1.94A1.942,1.942,0,0,0,17.92,14.03Z",
    transform: "translate(-11.98 -10.03)",
    fill: "#1a1b43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_31-2",
    "data-name": "Ellipse 31",
    transform: "translate(39.961 18.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M25.92,21.909a5.94,5.94,0,1,1,5.94-5.94A5.945,5.945,0,0,1,25.92,21.909Zm0-7.879a1.94,1.94,0,1,0,1.94,1.94A1.942,1.942,0,0,0,25.92,14.03Z",
    transform: "translate(-19.98 -10.03)",
    fill: "#1a1b43"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyComms);
export default __webpack_public_path__ + "static/media/icon-empty-comms.8b0ca64c478269960a2707d67652bdc3.svg";
export { ForwardRef as ReactComponent };